
import { Component, Prop, Watch } from "vue-property-decorator";
// import selectTime from "@/components/select-time/select-time.vue";
import { objAny } from "@/common/common-interface";
import { getSettlementOrderDetail } from "@/api/api-order-service";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    // "select-time": selectTime
    piSelectTableData
  }
})
export default class SystemConfigLog extends mixins(tableMaxHeight) {
  @Prop({ default: "" }) private tabName!: string;
  @Prop({ default: "" }) private activeTab!: string;
  private privilegeVoObj: objAny = {};

  private time: object[] = [];

  private total = 0;
  private loading = false;
  private formInline: objAny = {
    chargeOrderNo: "",
    startDate: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    oprPkId: "",
    endDate: ""
  };
  private ruleInline = {};
  private tableList: object[] = [
    {
      oprPkId: "11211",
      cardStatus: 1
    }
  ];
  private tableColumns: object[] = [];
  private searchShow = true;
  private allTableData: object[] = [
    {
      title: i18n.t("splitSettlement.chargingOrderNumber"),
      key: "chargeOrderNo",
      minWidth: 170
    },
    {
      title: i18n.t("splitSettlement.staName"),
      key: "staName",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.chargeVolume"),
      key: "chargeElect",
      width: 130
    },
    {
      title: i18n.t("splitSettlement.connectionfee"),
      key: "connectAmount",
      minWidth: 100
    },
    {
      title: i18n.t("splitSettlement.electricityBill"),
      key: "chargeAmount",
      minWidth: 100
    },
    {
      title: i18n.t("splitSettlement.serviceCharge"),
      key: "serviceAmount",
      minWidth: 100
    },
    {
      title: i18n.t("splitSettlement.chargeableAmount"),
      key: "totalAmount",
      minWidth: 180
    },
    {
      title: i18n.t("splitSettlement.discountAmount"),
      key: "discountAmount",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.totalAmountActuallyPaid"),
      key: "transactionAmount",
      minWidth: 170
    },
    {
      title: i18n.t("splitSettlement.partitionMethod"),
      key: "settlementRuleDesc",
      minWidth: 180
    },
    {
      title: i18n.t("splitSettlement.merchantIncome"),
      key: "merchantIncome",
      minWidth: 140
    },
    {
      title: i18n.t("splitSettlement.operatorShare"),
      key: "oprIncome",
      minWidth: 130
    },
    {
      title: i18n.t("splitSettlement.orderDate"),
      key: "createTime",
      width: 160
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      width: 130,
      align: "center"
    }
  ];
  private timeFnStartTime(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      const startDate = this.$common.userDate(val[0], "yyyy-MM-dd");
      const endDate = this.$common.userDate(val[1], "yyyy-MM-dd");
      this.time = [startDate, endDate];
      this.formInline.startDate = startDate;
      this.formInline.endDate = endDate;
    } else {
      this.formInline.startDate = "";
      this.formInline.endDate = "";
    }
  }

  public queryClick(): void {
    if (!this.formInline.startDate || !this.formInline.endDate) {
      this.$Message.error(i18n.t("formText.selectTimePl"));
      return;
    }

    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSettlementOrderDetail(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public init(newVal: string): void {
    if (newVal === this.tabName && this.tableList.length === 0) {
      this.getTableList();
    }
  }
  @Watch("activeTab")
  getVisible2(newVal: string): void {
    this.init(newVal);
  }
  public HandleDetail(item: objAny): void {
    this["$common"].save("charge-order-list-item", item); // 存在本地
    this["$router"].push(
      "/oper-manage/charge-order-list?orderNo=" + item.chargeOrderNo
    );
    // this.time = [startDate, endDate];
    // startDate: "2020-12-01"
    // endDate: "2020-12-03"
  }

  mounted() {
    const startDate = this.$common.thisTimes("yyyy-MM");
    const endDate = this.$common.thisTimes("yyyy-MM-dd");
    this.formInline.startDate = startDate + "-01";
    this.formInline.endDate = endDate;
    this.time = [this.formInline.startDate, this.formInline.endDate];

    this.init(this.activeTab);
    this.getTableList();
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
  }
}
